// Track Your Order and Contact Us pop-ups. Tracking uses the Shrine theme's 17TRACK widget; contact uses Shopify's own contact form.
(function () {
  "use strict";
  var $ = function (id) { return document.getElementById(id); };
  var track = $("gs-track"), contact = $("gs-contact"), last = null;
  function show(m, from) { last = from || document.activeElement; m.hidden = false; document.documentElement.classList.add("pm-open"); var f = m.querySelector("input:not([type=hidden]), textarea, .to-close"); if (f) f.focus(); }
  function hide(m) { m.hidden = true; document.documentElement.classList.remove("pm-open"); if (last && last.focus) last.focus(); }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-track-order-open], [data-contact-open]");
    if (a) { e.preventDefault(); if (a.hasAttribute("data-contact-open")) show(contact, a); else { loadWidget(); show(track, a); } return; }
    var c = e.target.closest && e.target.closest("[data-gs-close]");
    if (c) hide(c.closest(".to"));
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    [track, contact].forEach(function (m) { if (!m.hidden) hide(m); });
  });

  var loading = false;
  function loadWidget() {
    if (loading || window.YQV5) return;
    loading = true;
    var s = document.createElement("script");
    s.src = "https://www.17track.net/externalcall.js";
    document.head.appendChild(s);
  }
  $("gs-track-form").addEventListener("submit", function (e) {
    e.preventDefault();
    var num = $("gs-track-number").value.trim(), err = $("gs-track-error");
    err.hidden = true;
    if (!num) { err.textContent = "Please enter your tracking number."; err.hidden = false; return; }
    if (!window.YQV5) { err.textContent = "Tracking is still loading. Please try again in a moment."; err.hidden = false; loadWidget(); return; }
    window.YQV5.trackSingle({ YQ_ContainerId: "YQContainer", YQ_Height: 560, YQ_Fc: "0", YQ_Lang: "en", YQ_Num: num });
  });

  if (!contact.hidden) document.documentElement.classList.add("pm-open");
  if (location.hash === "#track-order") { loadWidget(); show(track); }
  if (location.hash === "#contact") show(contact);
})();
